import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaCheckCircle, FaHeart, FaTruck, FaHandshake, FaLightbulb, FaStar } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col>
          <h1 className="text-center mb-4">About Telering Process Pvt. Ltd.</h1>
          <div className="text-center mb-4">
            <p className="lead">
              Empowering businesses with high-quality office essentials for a seamless and hassle-free setup.
            </p>
          </div>
        </Col>
      </Row>

      {/* Our Story Section */}
      <Row className="mb-5 align-items-center">
        <Col lg={6} className="mb-4 mb-lg-0">
          <h2>Our Story</h2>
          <p>
            Founded with the mission to support India’s growing business ecosystem, **Telering Process Pvt. Ltd.** is committed to providing top-tier office essentials for startups, freelancers, and businesses of all sizes.
          </p>
          <p>
            What started as a simple vision to help businesses set up their offices quickly has grown into a trusted partner for companies across India. Our curated selection of furniture, tech, and office supplies is designed to ensure comfort, productivity, and efficiency.
          </p>
          <p>
            We understand the challenges that come with setting up an office, whether you're launching a startup or expanding a corporate space. That's why we provide a seamless experience from product selection to fast delivery, allowing you to focus on what matters most—your business.
          </p>
        </Col>
        <Col lg={6}>
          <Image 
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&auto=format&fit=crop&q=60" 
            alt="Modern office workspace" 
            fluid 
            className="rounded shadow"
          />
        </Col>
      </Row>

      {/* Our Mission Section */}
      <Row className="mb-5 py-5 bg-light rounded">
        <Col lg={12} className="text-center mb-4">
          <h2>Our Mission</h2>
          <p className="lead">
            To provide businesses with top-quality office essentials that foster productivity, innovation, and success.
          </p>
        </Col>
        <Col md={4} className="text-center mb-4 mb-md-0">
          <div className="p-4">
            <div className="bg-primary text-white rounded-circle d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
              <FaCheckCircle size={40} />
            </div>
            <h4>Quality</h4>
            <p>We deliver only the best products that meet the highest standards of quality, durability, and design.</p>
          </div>
        </Col>
        <Col md={4} className="text-center mb-4 mb-md-0">
          <div className="p-4">
            <div className="bg-primary text-white rounded-circle d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
              <FaHeart size={40} />
            </div>
            <h4>Customer Care</h4>
            <p>Our dedicated customer service team is always ready to support and guide you through every step of your journey.</p>
          </div>
        </Col>
        <Col md={4} className="text-center">
          <div className="p-4">
            <div className="bg-primary text-white rounded-circle d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
              <FaTruck size={40} />
            </div>
            <h4>Reliability</h4>
            <p>We ensure fast, secure delivery and hassle-free returns so you can focus on your business without any worries.</p>
          </div>
        </Col>
      </Row>

      {/* Values Section */}
      <Row className="mb-5">
        <Col lg={12} className="text-center mb-4">
          <h2>Our Values</h2>
          <p className="lead mb-5">
            The guiding principles that define how we do business
          </p>
        </Col>
        <Col md={6} lg={3} className="mb-4">
          <div className="p-4 bg-light rounded text-center h-100">
            <FaHandshake size={40} className="text-primary mb-3" />
            <h4>Customer First</h4>
            <p>We prioritize our customers in every decision we make and strive to exceed their expectations.</p>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-4">
          <div className="p-4 bg-light rounded text-center h-100">
            <FaStar size={40} className="text-primary mb-3" />
            <h4>Integrity</h4>
            <p>We operate with honesty, transparency, and respect in all our interactions.</p>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-4">
          <div className="p-4 bg-light rounded text-center h-100">
            <FaCheckCircle size={40} className="text-primary mb-3" />
            <h4>Quality</h4>
            <p>We only offer products that meet the highest standards of quality and durability.</p>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-4">
          <div className="p-4 bg-light rounded text-center h-100">
            <FaLightbulb size={40} className="text-primary mb-3" />
            <h4>Innovation</h4>
            <p>We constantly seek innovative solutions to help businesses grow and succeed in an ever-changing world.</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutPage;
